import {
  RESET_HEADER_OBJ,
  HEADER_ERROR,
  GET_CSAT,
  SET_CSAT,
  GET_NPS,
  SET_NPS,
  SET_HEADER_INDICATORS,
} from "./actionTypes";

export const resetHeaderObj = () => {
  return {
    type: RESET_HEADER_OBJ,
    payload: {},
  };
};

export const headerError = (error) => {
  return {
    type: HEADER_ERROR,
    payload: error,
  };
};

export const getCsat = () => {
  return {
    type: GET_CSAT,
    payload: {},
  };
};

export const setCsat = (data) => {
  return {
    type: SET_CSAT,
    payload: data,
  };
};

export const getNps = () => {
  return {
    type: GET_NPS,
    payload: {},
  };
};

export const setNps = (data) => {
  return {
    type: SET_NPS,
    payload: data,
  };
};

export const setHeaderIndicators = (data) => {
  return {
    type: SET_HEADER_INDICATORS,
    payload: data,
  };
};
